import context from '@truckdown/systems';
import { defineComponent, ref, Ref } from 'vue';
import { ApiKeyModel, IApiKeyService } from '@truckdown/accounts';

interface IData {
    statusMessage: Ref<string>,
    model: Ref<ApiKeyModel>,
    apiKey: Ref<string>
};

const getData = function (props: any) {
    return {
        statusMessage: ref<string>(""),
        model: ref<ApiKeyModel>(props.apiKey),
        apiKey: ref<string>(props.apiKey.apiKey)
    } as IData;
};

const getMethods = function (data: IData, ctx: any, id: string) {
    return {
        refreshApiKey: async function () {
            await confirmRefreshApiKey(data, ctx, id);
        }
    }
};

const confirmRefreshApiKey = async function (data: IData, ctx: any, id: string) {
    const apiKeyService = await context.getService<IApiKeyService>('IApiKeyService');
    const result = await apiKeyService.refresh(id);


    if (result && result.ok) {
        ctx.emit('update', id, result.data);
    } else {
        data.statusMessage.value = "API Key refresh was unsuccessful."
    }
};

export default defineComponent({
    name: "RefreshApiKey",
    props: {
        apiKey: {
            type: Object as () => ApiKeyModel,
            required: true
        }
    },
    emits: ['update'],
    setup: function (props, ctx: any) {

        const data = getData(props);
        const methods = getMethods(data, ctx, data.apiKey.value);

        return {
            ...data,
            ...methods
        };
    }
});

